import React, { useEffect, useState } from "react";
import { Title } from "../components";
import { DropDownWithButton } from "../../../../../../../../../../components";
import {
  BaseButtons,
  TextInputField,
} from "../../../../../../../../../../components/atoms";

const SocialMemberTerms = ({
  isSigned,
  dateCreated,
  signedAtAlready,
  userName,
  signedAt,
  setSignedAt,
  onAcceptClick,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 40,
          fontSize: 18,
        }}
      >
        SOCIAL CLUB MEMBERSHIP AGREEMENT
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        BETWEEN:
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        ROOFTOP 420 HOLDINGS (PTY) LTD T/A ROOFTOP 420 PRIVATE MEMBERS CLUB
        ("ROOFTOP 420")
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        AND
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        THE MEMBER
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        1. PURPOSE AND LEGAL COMPLIANCE
      </div>
      <div style={{ width: "90%" }}>
        1.1 This agreement outlines the terms under which a private adult
        individual ("the Member") may become a member of ROOFTOP 420 and access
        the services provided therein, including but not limited to the
        cultivation, storage, and personal use of cannabis.
      </div>
      <div style={{ width: "90%" }}>
        1.2 ROOFTOP 420 operates strictly in accordance with the Right to
        Privacy established by the South African Constitutional Court in
        Minister of Justice and Constitutional Development & Others v Prince
        [2018] ZACC 30 and the Cannabis for Private Purposes Act ("CFPPA").
      </div>
      <div style={{ width: "90%" }}>
        1.3 All cannabis cultivation and sharing occur within private spaces and
        strictly among consenting adult members, with no exchange of
        consideration, reward, or commercial transaction.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        2. MEMBERSHIP AND REGISTRATION
      </div>
      <div style={{ width: "90%" }}>
        2.1 Membership is available only to individuals 21 years or older. Proof
        of age and identity must be submitted upon registration.
      </div>
      <div style={{ width: "90%" }}>
        2.2 Upon approval, the Member will receive access credentials to use
        ROOFTOP 420’s application and private premises.
      </div>
      <div style={{ width: "90%" }}>
        2.3 By registering, the Member agrees to these Terms and Conditions and
        affirms they will only use cannabis cultivated through this agreement
        for personal, private use.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        3. SERVICES
      </div>
      <div style={{ width: "90%" }}>
        3.1 ROOFTOP 420 administers the cultivation, collection, and storage of
        members' cannabis through Professional Horticultural Services Providers.
      </div>
      <div style={{ width: "90%" }}>
        3.2 All services rendered by horticultural providers are on behalf of
        the Member, who remains the sole legal owner of their cannabis.
      </div>
      <div style={{ width: "90%" }}>
        3.3 No sale, distribution, or commercialisation of cannabis by any party
        is permitted.
      </div>
      <div style={{ width: "90%" }}>
        3.4 Costs incurred for cultivation are shared pro-rata among members who
        consensually participate in crop sharing.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        4. LEGAL UNDERTAKINGS
      </div>
      <div style={{ width: "90%" }}>
        4.1 Members warrant that they will not engage in unlawful activities
        including the sale, trade, or distribution of cannabis.
      </div>
      <div style={{ width: "90%" }}>
        4.2 Any contravention will result in immediate termination of membership
        and potential legal liability.
      </div>
      <div style={{ width: "90%" }}>
        4.3 Indemnification is provided to ROOFTOP 420 and service providers
        against any damages or claims arising from members’ unlawful acts.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        5. CULTIVATION AND HARVEST
      </div>
      <div style={{ width: "90%" }}>
        5.1 Members agree to the cultivation of their crop by assigned
        horticultural providers, who are experienced and capable.
      </div>
      <div style={{ width: "90%" }}>
        5.2 Cannabis will be harvested, dried, cured, and stored in a
        professional manner.
      </div>
      <div style={{ width: "90%" }}>
        5.3 Upon readiness, members will be notified to collect their harvest,
        which must be done in person with ID.
      </div>
      <div style={{ width: "90%" }}>
        5.4 Sharing among members is permitted only where expressly agreed to,
        and always without consideration.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        6. TERMINATION AND CHANGES IN LAW
      </div>
      <div style={{ width: "90%" }}>
        6.1 ROOFTOP 420 reserves the right to modify this agreement in response
        to changes in legislation.
      </div>
      <div style={{ width: "90%" }}>
        6.2 Should the legal framework change such that services rendered become
        non-compliant, ROOFTOP 420 shall inform Members and take appropriate
        action to ensure ongoing compliance.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        7. GENERAL
      </div>
      <div style={{ width: "90%" }}>
        7.1 This agreement does not constitute a partnership, joint venture, or
        employment relationship.
      </div>
      <div style={{ width: "90%" }}>
        7.2 Each party acknowledges full understanding of and consent to these
        terms.
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "90%",
          marginTop: 20,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        8. Protection of Personal Information (POPI) Consent Clause
      </div>
      <div style={{ width: "90%" }}>
        8.1 By using this website and/or engaging with our services, you consent
        to the collection, processing, storage, and use of your personal
        information in accordance with the Protection of Personal Information
        Act, 4 of 2013 (“POPIA”).
      </div>
      <div style={{ width: "90%" }}>
        8.2 We may collect, store, and process your personal data for purposes
        including, but not limited to:
      </div>
      <div style={{ width: "90%" }}>
        - Providing products or services requested by you
      </div>
      <div style={{ width: "90%" }}>
        - Communicating with you regarding our services or offerings
      </div>
      <div style={{ width: "90%" }}>- Marketing and promotional purposes</div>
      <div style={{ width: "90%" }}>- Statistical and analytical purposes</div>
      <div style={{ width: "90%" }}>- Compliance with legal obligations</div>
      <div style={{ width: "90%" }}>
        - Internal record-keeping and business operations
      </div>
      <div style={{ width: "90%" }}>
        8.3 You understand and accept that your information may be shared with
        third-party service providers or affiliates where necessary to fulfill
        the above purposes. We undertake to only share data where appropriate
        agreements and safeguards are in place, as required by POPIA. You have
        the right to access, correct, or request deletion of your personal
        information, and may withdraw consent at any time by contacting us.
      </div>
      <div style={{ width: "90%" }}>
        By continuing to use this site or service, you acknowledge that you have
        read, understood, and agreed to this clause and our full privacy policy.
      </div>

      <div style={{ width: "90%" }}>
        You understand and accept that your information may be shared with
        third-party service providers or affiliates where necessary to fulfill
        the above purposes. We undertake to only share data where appropriate
        agreements and safeguards are in place, as required by POPIA. You have
        the right to access, correct, or request deletion of your personal
        information, and may withdraw consent at any time by contacting us. By
        continuing to use this site or service, you acknowledge that you have
        read, understood, and agreed to this clause and our full privacy policy.
      </div>

      <div>
        <TextInputField
          mini={true}
          invert={true}
          labelTitle={"SIGNED AT"}
          readOnly={isSigned ? true : false}
          value={isSigned ? signedAtAlready : signedAt}
          onChange={(e) => setSignedAt(e.target.value)}
        />
      </div>
      <div>
        <TextInputField
          mini={true}
          invert={true}
          labelTitle={"DATE"}
          readOnly={isSigned ? true : false}
          value={isSigned ? dateCreated : new Date().toDateString()}
        />
      </div>
      <div style={{ marginBottom: 20 }}>
        <TextInputField
          mini={true}
          invert={true}
          labelTitle={"MEMBER FULL NAME"}
          readOnly={true}
          value={userName}
        />
      </div>
      {isSigned ? null : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <BaseButtons
            disable={signedAt === "" ? true : false}
            label={"ACCEPT AGREEMENT"}
            width={"100%"}
            marginTopFalse={true}
            size={"80%"}
            onClick={onAcceptClick}
          />
        </div>
      )}
    </div>
  );
};

export default SocialMemberTerms;
